export default __webpack_public_path__ + "09185275b27e9c86b00cb6b26c3c1a0e.svg";